(function () {
    'use strict';

    angular.module("imApp").factory("portalUserSignatureService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 975,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 976,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
